/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import e from"../../../geometry/Polyline.js";function t(t,l){const n=t.samples??[],s=n.length-1,o=[];let r=[];for(let e=0;e<=s;e++){const{x:t,y:l,z:p}=n[e];null!=p&&r.push([t,l,p]),e!==s&&null!=p||!r.length||(o.push(r),r=[])}return new e({paths:o,hasZ:!0,spatialReference:l})}export{t as createLineGeometry};
